import { useDispatch, useSelector } from 'react-redux';
import { getTemplatesRequest } from 'store/storageunits/sagaActions';
import { LIMIT } from 'config/paginationConfig';
import {
  getHasMoreDataToRetrieve,
  getSearchString,
  getTemplatesForDashboard,
} from 'store/storageunits/selectors';
import {
  ExplorerMode,
  SortType,
  StorageUnitType,
} from 'store/storageunits/types';
import FileArea from '../components/FileArea';
import StorageUnitGrid from '../components/StorageUnitGrid';
import { useDashboard } from '../context';
import StorageUnitList from '../components/StorageUnitList';
import { useFetchViewStorageUnits } from '../hooks/useFetchViewStorageUnits';

const Templates = () => {
  const searchString = useSelector(getSearchString);
  const { explorerMode } = useDashboard();
  const dispatch = useDispatch();
  const moreDataToRetrieve = useSelector(getHasMoreDataToRetrieve);

  const templates = useSelector(getTemplatesForDashboard);

  useFetchViewStorageUnits(getTemplatesRequest, {
    limit: LIMIT,
    offset: 0,
    searchString,
  });

  const fetchMore = async () => {
    dispatch(
      getTemplatesRequest({
        limit: LIMIT,
        offset: templates.length,
        searchString,
        replace: false,
      }),
    );
  };

  return (
    <FileArea
      dataLength={templates.length}
      fetchMore={fetchMore}
      canFetchMore={moreDataToRetrieve}
    >
      {explorerMode === ExplorerMode.Grid ? (
        <StorageUnitGrid
          title='Templates'
          type={StorageUnitType.File}
          units={templates}
          showSorter
        />
      ) : (
        <StorageUnitList
          units={templates}
          columns={[
            { label: 'Name', type: SortType.ALPHABETICAL },
            { label: 'Access' },
            {
              label: 'Last modified',
              type: SortType.LAST_MODIFIED,
            },
            { label: 'Locked' },
            { label: 'Downloaded' },
          ]}
        />
      )}
    </FileArea>
  );
};

export default Templates;
